module.exports = "/_next/static/images/278ddcc6be5e656f247c12e079ce3bb7-cajitas-left-mobile.jpg.webp";